export const permissions = {
	Admin: ['*'],
	Users: [],
	Client_Admin: [],
	Installers: [],
	Support: ['*'],
};
